import * as t from "./actionType";

const initialState = {
  // RECORDING
  recordingList: [],
  recordingListLoading: false,
  recordingData: [],
  recordingDataLoading: false,
  recordingDispatch: [],
  recordingDispatchLoading: false,
  recordingUpdate: [],
  recordingUpdateLoading: false,
  recordingDelete: [],
  recordingDeleteLoading: false,
  recordingRetrySummary: [],
  recordingRetrySummaryLoading: false,
  recordingSync: [],
  recordingSyncLoading: false,
  // SETTINGS
  settings: [],
  settingsLoading: false,
  settingsUpdate: [],
  settingsUpdateLoading: false,
};

const MeetingRecording = (state = initialState, action) => {
  switch (action.type) {
    // ---------- RECORDING ----------
    case t.MEETING_RECORDING_LIST:
      return { ...state, recordingListLoading: true };
    case t.MEETING_RECORDING_LIST_SUCCESS:
      return {
        ...state,
        recordingList: action.data,
        recordingListLoading: false,
      };
    case t.MEETING_RECORDING_LIST_FAIL:
      return { ...state, recordingListLoading: false };

    case t.MEETING_RECORDING_DATA:
      return { ...state, recordingDataLoading: true };
    case t.MEETING_RECORDING_DATA_SUCCESS:
      return {
        ...state,
        recordingData: action.data,
        recordingDataLoading: false,
      };
    case t.MEETING_RECORDING_DATA_FAIL:
      return { ...state, recordingDataLoading: false };

    case t.MEETING_RECORDING_DISPATCH:
      return { ...state, recordingDispatchLoading: true };
    case t.MEETING_RECORDING_DISPATCH_SUCCESS:
      return {
        ...state,
        recordingDispatch: action.data,
        recordingDispatchLoading: false,
      };
    case t.MEETING_RECORDING_DISPATCH_FAIL:
      return { ...state, recordingDispatchLoading: false };
    case t.MEETING_RECORDING_DISPATCH_RESET:
      return { ...state, recordingDispatch: [] };

    case t.MEETING_RECORDING_UPDATE:
      return { ...state, recordingUpdateLoading: true };
    case t.MEETING_RECORDING_UPDATE_SUCCESS:
      return {
        ...state,
        recordingUpdate: action.data,
        recordingUpdateLoading: false,
      };
    case t.MEETING_RECORDING_UPDATE_FAIL:
      return { ...state, recordingUpdateLoading: false };
    case t.MEETING_RECORDING_UPDATE_RESET:
      return { ...state, recordingUpdate: [] };

    case t.MEETING_RECORDING_DELETE:
      return { ...state, recordingDeleteLoading: true };
    case t.MEETING_RECORDING_DELETE_SUCCESS:
      return {
        ...state,
        recordingDelete: action.data,
        recordingDeleteLoading: false,
      };
    case t.MEETING_RECORDING_DELETE_FAIL:
      return { ...state, recordingDeleteLoading: false };
    case t.MEETING_RECORDING_DELETE_RESET:
      return { ...state, recordingDelete: [] };

    case t.MEETING_RECORDING_RETRY_SUMMARY:
      return { ...state, recordingRetrySummaryLoading: true };
    case t.MEETING_RECORDING_RETRY_SUMMARY_SUCCESS:
      return {
        ...state,
        recordingRetrySummary: action.data,
        recordingRetrySummaryLoading: false,
      };
    case t.MEETING_RECORDING_RETRY_SUMMARY_FAIL:
      return { ...state, recordingRetrySummaryLoading: false };
    case t.MEETING_RECORDING_RETRY_SUMMARY_RESET:
      return { ...state, recordingRetrySummary: [] };

    case t.MEETING_RECORDING_SYNC:
      return { ...state, recordingSyncLoading: true };
    case t.MEETING_RECORDING_SYNC_SUCCESS:
      return {
        ...state,
        recordingSync: action.data,
        recordingSyncLoading: false,
      };
    case t.MEETING_RECORDING_SYNC_FAIL:
      return { ...state, recordingSyncLoading: false };
    case t.MEETING_RECORDING_SYNC_RESET:
      return { ...state, recordingSync: [] };

    // ---------- SETTINGS ----------
    case t.MEETING_RECORDING_SETTINGS:
      return { ...state, settingsLoading: true };
    case t.MEETING_RECORDING_SETTINGS_SUCCESS:
      return { ...state, settings: action.data, settingsLoading: false };
    case t.MEETING_RECORDING_SETTINGS_FAIL:
      return { ...state, settingsLoading: false };

    case t.MEETING_RECORDING_SETTINGS_UPDATE:
      return { ...state, settingsUpdateLoading: true };
    case t.MEETING_RECORDING_SETTINGS_UPDATE_SUCCESS:
      return {
        ...state,
        settingsUpdate: action.data,
        settingsUpdateLoading: false,
      };
    case t.MEETING_RECORDING_SETTINGS_UPDATE_FAIL:
      return { ...state, settingsUpdateLoading: false };
    case t.MEETING_RECORDING_SETTINGS_UPDATE_RESET:
      return { ...state, settingsUpdate: [] };

    default:
      return state;
  }
};

export default MeetingRecording;
